// extracted by mini-css-extract-plugin
export default {"container":"NoticeListPage_container__+4xqR","content":"NoticeListPage_content__gtTA5","empty":"NoticeListPage_empty__yYYJo","writeButton":"NoticeListPage_writeButton__9stB8"};